@for (section of mspPortals; track section.id) {
  <div class="ms__portal w-100 my-3">
    <span class="ms__portal-title ml-4">{{ section.name }}</span>
    <div class="d-flex flex-wrap">
      @for (portal of section.portals; track portal.id) {
        <div class="ms__portal-card d-flex m-3">
          <div class="ms__portal-card-icon d-flex align-items-center justify-content-center">
            <div class="icon-container d-flex align-items-center justify-content-center">
              <img src="'../../../../../assets/images/icons/{{ portal.icon }}" alt="" />
            </div>
          </div>
          <div class="ms__portal-card-content">
            <div class="content-division">
              <p class="card-title">
                {{ portal.name }}
                @if (validateExternalSection(portal.url)) {
                  <img src="../../../../../assets/images/icons/redirect-icon-blue.svg" width="15px" class="mb-2 ml-2" />
                }
              </p>
            </div>
            <div class="content-division">
              <p class="card-desc">{{ portal.description }}</p>
            </div>
            <div class="content-division">
              <button class="card-btn" (click)="openSection(portal.url)">Open</button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
@if (isLoading) {
  <div class="empty-portals">
    <mat-spinner [diameter]="36"></mat-spinner>
    <span class="ml-3 mb-0" style="font-size: 14pt">Loading Portals…</span>
  </div>
}
